import React, { useEffect, useMemo, useState } from 'react';
import { api } from '../../api.js';
import PageHeader from '../../components/PageHeader.jsx';
import { Icon, SECTION_COLOR } from '../../icons.jsx';
import AccessoryFormModal from './AccessoryFormModal.jsx';

const TrashIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>;

const STATUS_COLOR = { 'Available': 'var(--green)', 'On Trip': 'var(--blue)', 'Out of Service': 'var(--red)', 'Inactive': 'var(--text-dim)' };

export default function AccessoryList() {
  const [accessories, setAccessories] = useState(null);
  const [query, setQuery] = useState('');
  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  function load() {
    setAccessories(null);
    api('/dispatch/accessories').then(setAccessories).catch(() => setAccessories([]));
  }

  const deleteAccessory = async (e, a) => {
    e.stopPropagation();
    if (!window.confirm(`Delete "${a.name}"? This can't be undone.`)) return;
    await api(`/dispatch/accessories/${a.id}`, { method: 'DELETE' });
    load();
  };

  useEffect(() => { load(); }, []);

  const filtered = useMemo(() => {
    if (!accessories) return [];
    const q = query.trim().toLowerCase();
    if (!q) return accessories;
    return accessories.filter(a => [a.name, a.ref_number, a.type, a.serial_number].filter(Boolean).some(v => v.toLowerCase().includes(q)));
  }, [accessories, query]);

  return (
    <div>
      <PageHeader
        icon={Icon.control}
        title="Accessories"
        subtitle="Load bars, straps, chains, tarps, dollies — any transport equipment you assign and track"
        color={SECTION_COLOR.control}
        actions={<button className="primary-btn" onClick={() => { setEditing(null); setFormOpen(true); }}>+ New accessory</button>}
      />

      <div className="panel filter-row-panel">
        <div className="filter-row">
          <input placeholder="Type to filter..." value={query} onChange={e => setQuery(e.target.value)} style={{ width: 240 }} />
        </div>
      </div>

      {accessories === null && <div className="empty">Loading...</div>}
      {accessories && accessories.length === 0 && <div className="empty">No accessories yet — click "+ New accessory" above.</div>}

      {accessories && accessories.length > 0 && (
        <table>
          <thead>
            <tr><th>Ref#</th><th>Name</th><th>Type</th><th>Serial #</th><th>Assigned Truck</th><th>Assigned Driver</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {filtered.map(a => (
              <tr key={a.id} onClick={() => { setEditing(a); setFormOpen(true); }} style={{ cursor: 'pointer' }}>
                <td>{a.ref_number || '—'}</td>
                <td>{a.name}</td>
                <td>{a.type || '—'}</td>
                <td>{a.serial_number || '—'}</td>
                <td>{a.truck_unit_number || '—'}</td>
                <td>{a.driver_name || '—'}</td>
                <td style={{ color: STATUS_COLOR[a.status] || 'var(--text-dim)', fontWeight: 600 }}>{a.status}</td>
                <td>
                  <button type="button" title="Delete accessory" onClick={e => deleteAccessory(e, a)}
                    style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 30, height: 30, border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--red)', cursor: 'pointer', padding: 0 }}>
                    <TrashIcon />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {formOpen && (
        <AccessoryFormModal accessory={editing} onClose={() => setFormOpen(false)} onSaved={() => { setFormOpen(false); load(); }} />
      )}
    </div>
  );
}
